import { isFullRemoteOnlyByQueryParam } from '@/domain/search/helpers';
import { unscrambleStringId } from '@/helpers/xing-one';
import type { SearchQueryFiltersLegacy } from '@/types';

import { ITEMS_PER_PAGE } from '../../../constants';
import { useSearchQuery } from '../../../contexts';
import { ListType } from './results-list';

type UrlParamsObject = {
  paging_context: string;
  search_query?: {
    keywords?: string | null;
    location?: string | null;
    radius?: string | null;
    filter?: SearchQueryFiltersLegacy;
    limit?: number;
    offset?: number;
    sort?: string;
    page?: number;
  };
  ijt: string;
};

export const useJDPUrlParams = (type: ListType) => {
  const {
    page,
    sort,
    queryParams: [queryParams],
    alertQuery,
  } = useSearchQuery();

  const isFullRemoteOnly = isFullRemoteOnlyByQueryParam(queryParams.remoteOption);
  const shouldAddDistanceFilter = queryParams.cityId && !isFullRemoteOnly;
  const legacyQuery = {
    ...alertQuery,
    ...(shouldAddDistanceFilter && {
      filter: {
        ...alertQuery.filter,
        // legacy distance filter can be used to send the cityId (without coordinates)
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        distance: [unscrambleStringId(queryParams.cityId!)],
      },
    }),
  };

  const { keywords, location, radius, filter } = legacyQuery;

  const urlParams: Record<ListType, UrlParamsObject> = {
    SEARCH: {
      paging_context: 'search',
      search_query: {
        keywords,
        location,
        radius,
        filter,
        limit: ITEMS_PER_PAGE,
        offset: ITEMS_PER_PAGE * (page - 1),
        sort,
        page,
      },
      ijt: 'jb_18',
    },
    EMPTY_STATE_SEARCH: {
      paging_context: 'search',
      search_query: {
        keywords,
        filter,
        limit: ITEMS_PER_PAGE,
        offset: ITEMS_PER_PAGE * (page - 1),
      },
      ijt: 'jb_37',
    },
    EMPTY_STATE_RECOS: {
      paging_context: 'reco',
      ijt: 'jb_36',
    },
  };

  return urlParams[type] ?? urlParams['SEARCH'];
};
